import React from 'react';
import PropTypes from 'prop-types';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import Button from 'tailwind-components/Button/Button';

/**
 * prev/next pager for the call review tables. disabling the buttons at the bounds
 * is what keeps an out-of-range page from ever reaching the api, which answers 400.
 * spacing is left to the caller so it can sit in a card header or under a table.
 * @param page - current 1-indexed page
 * @param totalPages - total pages reported by the api
 * @param onPageChange - called with the page to move to
 */
export default function TablePager({ page, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  return (
    <div className='flex shrink-0 items-center gap-3'>
      <Button
        variant='default'
        outlined
        size='xsmall'
        rounded='medium'
        text='Previous'
        icon={<ChevronLeft />}
        isDisabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
      />
      <span className='whitespace-nowrap text-[length:--font-size-body] text-grey'>
        Page {page} of {totalPages}
      </span>
      <Button
        variant='default'
        outlined
        size='xsmall'
        rounded='medium'
        text='Next'
        icon={<ChevronRight />}
        iconPosition='right'
        isDisabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}
      />
    </div>
  );
}

TablePager.propTypes = {
  page: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired
};
